export default class SpaceMembershipModalController {
  public space: any;
  public owner: any;
  public account: any;
  private $close: any;

  static $inject = [];

  constructor() {}
}
